










import { defineComponent, ref, onMounted, onUpdated, computed } from '@vue/composition-api';
//import Hls from 'hls.js';
//import Constants from '@/utils/Constants';

export default defineComponent({


  // This component has been disabled because it's not in use
  // and if we don't need it, we don't want to import hls.
  // Leaving it for informational purposes.


  name: 'NativePlayer',
  props: {
    sourceUrl: {
      type: String,
      required: true
    },
    posterUrl: {
      type: String,
      default: undefined
    }
  },
  setup(props) {
    const videoElem = ref<HTMLVideoElement|null>(null);
    //let hls: Hls|undefined = undefined;
    
    // const detachVideo = () => {
    //   return;
    //   // if(!videoElem?.value?.src) return;
    //   // if(hls) {
    //   //   hls.detachMedia();
    //   // }
    // };

    const attachVideo = () => {

      return;

      // detachVideo();

      // if(!videoElem.value) return;
      // if(videoElem.value.canPlayType(Constants.mimeTypeHls)) {
      //   videoElem.value.src = props.sourceUrl;
      // }
      // else if(hls) {
      //   hls.loadSource(props.sourceUrl);
      //   hls.attachMedia(videoElem.value);
      //   hls.once(Hls.Events.FRAG_PARSED , () => {
      //     hls?.stopLoad();
      //   });
      //   const onStartLoad = () => {
      //     hls?.startLoad(-1);
      //     videoElem.value?.removeEventListener('play', onStartLoad);
      //   };
      //   videoElem.value.addEventListener('play', onStartLoad);
      // }
    };

    const videoAttrs = computed(() => {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      const attrs: any = {
        ref: 'videoElem',
        controls: true,
        preload: 'metadata'
      };
      if(props.posterUrl) {
        attrs.poster = props.posterUrl
      }
      return attrs;
    });

    onUpdated(() => {
      attachVideo();
    });

    onMounted(() => {
      if(!videoElem.value) return;

      // if(!videoElem.value.canPlayType(Constants.mimeTypeHls) && Hls.isSupported()) {
      //   hls = new Hls();
      // }
      // attachVideo();
    });
    return {
      videoElem,
      videoAttrs
    }
  }
});
